// removed by extract-text-webpack-plugin
module.exports = {"container":"MergeRequestModal-container","title":"MergeRequestModal-title","error":"MergeRequestModal-error"};